import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import ExpensableDetail from 'modules/expenses/components/expenses/Detail'

import { useExpenses } from 'modules/expenses/pages/ExpensesContext'

const GroupExpenseDetailPage = () => {
  const navigate = useNavigate()
  const { expense_id, groupId } = useParams()
  const { navigation } = useNavigation()
  const [searchParams] = useSearchParams()
  const { featureAvailabilities, data } = useExpenses()

  if (!expense_id || !groupId) {
    throw new Error('Required expense_id and groupId param')
  }

  const currencies = data?.apiCore?.currencies ?? []

  return (
    <ExpensableDetail
      expensableId={expense_id}
      onClose={() =>
        navigate({
          pathname: navigation.expenses.groups.id.fullPath({ groupId }),
          search: searchParams.toString(),
        })
      }
      taxAgencyHomologationEnabled={featureAvailabilities.taxAgencyHomologation}
      reimburseThroughPayrollEnabled={featureAvailabilities.reimburseThroughPayroll}
      reimburseThroughSepaEnabled={featureAvailabilities.reimburseThroughSepa}
      reportOnBehalfEnabled={featureAvailabilities.reportOnBehalf}
      canUseSpendingPolicies={featureAvailabilities.canUseSpendingPolicies}
      canCreateExpensesForOthers={data.expenses._policies.expenseCreateExpensesForOthers.can}
      canOverrideApprovalFlow={data.expenses._policies.expenseOverrideApprovalFlow.can}
      canSetExpensableToPaid={data.expenses._policies.expenseSetToPaid.can}
      canRestartApprovalFlow={data.expenses._policies.expenseRestartApprovalFlow.can}
      canSeeEmployeeLegalEntity={data.expenses._policies.expenseSeeEmployeeLegalEntity.can}
      canCustomizeSettings={data.expenses._policies.expenseCustomizeSettings.can}
      projectsManagementEnabled={featureAvailabilities.projectsManagement}
      currencies={currencies}
      accountingTabEnabled
      hasCostCentersFeature={featureAvailabilities.hasCostCentersFeature}
      showRecommendationSystem
      payrollData={data.payroll}
    />
  )
}

export default GroupExpenseDetailPage
